import React from 'react'
import { Button } from '@mui/material'
import { CheckCircleOutline, Facebook, Instagram, YouTube, Twitter } from '@mui/icons-material'
import './success.css'

const success = () => {
  return (
    <>
      <div className='success-wrapper'>
        <CheckCircleOutline style={{ color: '#37b983', fontSize: 80 }} />
        <h2 style={{ marginTop: '.5rem', color: '#37b983' }}>Congratulations!</h2>
        <p>
          You have been successfully registered to the Webinar. You will receive an email with the details of the
          registration.
        </p>
        <Button
          color='secondary'
          style={{ marginTop: '1rem' }}
          href='https://www.youtube.com/playlist?list=PLDOmrTJ17R0Dm-5MeF8CtixJilvkeyCVm'
          target='_blank'
          rel='noopener noreferrer'
        >
          Check Other Webinars
        </Button>
        <div className='social-media'>
          <section />
          <h4>Follow us on Social Media</h4>
          <a href='https://www.facebook.com/GemvisionCorp/' target='_blank' rel='noopener noreferrer'>
            <Facebook />
          </a>
          <a href='https://www.instagram.com/gemvisioncorp/' target='_blank' rel='noopener noreferrer'>
            <Instagram />
          </a>
          <a href='https://www.youtube.com/GemvisionCorp' target='_blank' rel='noopener noreferrer'>
            <YouTube />
          </a>
          <a href='https://twitter.com/GemvisionCorp' target='_blank' rel='noopener noreferrer'>
            <Twitter />
          </a>
        </div>
      </div>
    </>
  )
}

export default success
